module.exports = __webpack_public_path__ + "fonts/5dd6e42.ttf";